var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path0, _path1, _g, _path10, _path11, _circle2, _circle3, _path12, _circle4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWishNothing = function SvgWishNothing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wishNothing_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.184 72.993c1.744 1.754 3.439 3.578 5.261 5.254 1.182 1.092 1.201 1.814 0 2.964-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.271-49.994 6.493-72.889-8.317-3.798-2.456-7.092-5.713-10.629-8.57-1.114-.906-1.153-1.627-.077-2.67 3.73-3.657 7.392-7.38 11.045-11.115.97-.975 1.638-1.102 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.838 20.191 4.427 38.26-.087 53.986-13.668 2.732-2.36 2.693-2.399 5.222.126l4.418 4.446z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "wishNothing_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.612 103.616c-25.071 0-43.705-12.196-48.787-16.94l-59.524-50.185L60.61-9 159.5 31l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#wishNothing_svg__b)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7CEDC",
    d: "M34.588 104.016h48.826a8.587 8.587 0 0 0 8.587-8.587V50.368a5.15 5.15 0 0 0-5.152-5.153H53.654a7.71 7.71 0 0 1-6.81-4.1 7.71 7.71 0 0 0-6.811-4.1h-8.88a5.15 5.15 0 0 0-5.152 5.153v53.26a8.587 8.587 0 0 0 8.587 8.588"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "wishNothing_svg__c",
    width: 67,
    height: 61,
    x: 26,
    y: 36,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC5D1",
    d: "M35.588 96.998h47.826a8.587 8.587 0 0 0 8.587-8.587V50.497a5.15 5.15 0 0 0-5.206-5.152l-32.619.344a8.12 8.12 0 0 1-7.276-4.345 8.12 8.12 0 0 0-7.19-4.346h-7.558a5.15 5.15 0 0 0-5.153 5.152l.002 46.261a8.587 8.587 0 0 0 8.587 8.587"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#wishNothing_svg__c)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE6F4",
    d: "M43.078 36.844h6.463l-13.464 57.09h-6.463z",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "wishNothing_svg__d",
    width: 66,
    height: 60,
    x: 27,
    y: 37,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC5D1",
    d: "M36.047 96.295h47.457a8.587 8.587 0 0 0 8.587-8.587V49.525a5.15 5.15 0 0 0-5.153-5.152H54.23a7.35 7.35 0 0 1-6.36-3.661 7.35 7.35 0 0 0-6.359-3.661h-8.898a5.15 5.15 0 0 0-5.152 5.152v45.505a8.587 8.587 0 0 0 8.587 8.587"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#wishNothing_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102.693,
    cy: 44.83,
    r: 35.611,
    fill: "#B9C2D1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7CEDC",
    d: "M29.001 97.516v-37.5l11 3.86v33.64a5.5 5.5 0 0 1-11 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.52,
    d: "M56.011 65.994S34.578 49.156 23.651 54.09c-10.928 4.935 5.519 15.513 10.242 6.904S22.92 38.369 11 39.515"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M90.413 103.998H37v-40.54a4.46 4.46 0 0 1 4.46-4.46h53.08a4.46 4.46 0 0 1 4.46 4.46v31.953a8.587 8.587 0 0 1-8.587 8.587"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.238,
    cy: 10.238,
    r: 10.238,
    fill: "#F45149",
    transform: "matrix(-1 0 0 1 98.522 16)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.566 23.238a3 3 0 0 1 4.242 0h.002a3 3 0 0 1 4.243 4.243l-.057.054-3.733 3.733a.643.643 0 0 1-.91 0l-3.787-3.788a3 3 0 0 1 0-4.242"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "wishNothing_svg__e",
    width: 59,
    height: 52,
    x: 41,
    y: 59,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M90.414 111H41V63.46A4.46 4.46 0 0 1 45.46 59h49.08A4.46 4.46 0 0 1 99 63.46v38.953A8.587 8.587 0 0 1 90.414 111"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#wishNothing_svg__e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108.501,
    cy: 57.5,
    r: 41.5,
    fill: "#A7B1C1",
    opacity: 0.2
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "M98 39 82 55"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "m89.62 87.184 29.25 17.793-3.218 5.291-29.25-17.793z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.742,
    cy: 80.744,
    r: 17,
    fill: "#BCC4D4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.742,
    cy: 80.744,
    r: 12,
    fill: "#D1D8E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D9AE8",
    d: "M74.704 84.654v-.441q0-1.702.861-2.926.34-.48.742-.861.4-.381.961-.822.601-.46.922-.781.321-.34.42-.722.061-.24.061-.48 0-.481-.28-.882a2 2 0 0 0-.722-.541 2.04 2.04 0 0 0-.922-.22q-.96 0-1.583.46-.58.461-.821 1.383l-.1.42-2.966-.76.1-.422q.501-1.983 1.844-3.005 1.362-1.042 3.486-1.042 1.143 0 2.104.34a4.3 4.3 0 0 1 1.643 1.022q.662.621 1.002 1.503.36.863.361 1.844 0 .84-.3 1.483-.281.64-.702 1.082-.4.44-1.082 1.041-.902.762-1.343 1.383-.42.601-.42 1.523v.44zm1.743 4.709q-.782 0-1.343-.561-.54-.541-.54-1.363 0-.781.54-1.322a1.83 1.83 0 0 1 1.343-.562q.78 0 1.342.562.561.54.561 1.322 0 .781-.54 1.363a1.86 1.86 0 0 1-1.363.56"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "wishNothing_svg__f",
    width: 35,
    height: 35,
    x: 59,
    y: 63,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.742,
    cy: 80.742,
    r: 17,
    fill: "#BCC4D4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#wishNothing_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.001,
    cy: 65,
    fill: "#ECF1FA",
    opacity: 0.3,
    rx: 19,
    ry: 18
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wishNothing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgWishNothing;